import styled from 'styled-components';

import { media, space, rems } from '../../ui/helpers';
import fonts from '../../ui/fonts';
import { colors } from '../../ui/design-tokens';

const Module = styled.div`
  padding: ${space(8)} ${space(3)};
  background: ${({ theme }) => theme.background};
  max-width: 100%;
  text-align: center;

  ${media.min('medium')`
    padding: ${space(14)} ${space(3)};
  `}

  .title {
    margin-bottom: ${space(6)};
    text-align: center;
  }
`;

const Container = styled.div`
  color: ${({ theme }) => theme.color};
  overflow: hidden;
  padding: 0;
  position: relative;

  .quotes:first-child {
    text-align: center;
    padding-bottom: ${space(3)};
  }

  .quotes:last-child {
    bottom: ${space(3)};
    position: absolute;
    right: ${space(3)};
    transform: rotate(180deg);
  }

  .quote {
    height: ${rems(60)};
    width: ${rems(70)};

    path {
      // fill: ${({ theme }) => theme.quotes};
      fill: ${colors.primary[500]};
    }
  }

  ${media.min('medium')`
    padding: 0;
  `}
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  .p-big {
    margin-bottom: ${space(3)};
    ${fonts.titleSM};
  }

  .person {
    ${fonts.bodySM};
    justify-content: center;
    display: flex;
    text-align: center;
    flex-direction: column;

    ${media.min('medium')`
      justify-content: center;
      text-align: center;
      flex-direction: row;
    `}

    p:not(:only-child):first-child:after {
      color: ${({ theme }) => theme.icon};
      content: '|';
      margin: 0 ${space(1)};

      ${media.min('medium')`
        justify-content: center;
      `}
    }
  }

  .image,
  .video {
    margin-top: ${space(6)};
    width: 100%;

    img {
      border-radius: 0;
    }
  }
`;

export { Module, Container, Inner };
